import React from 'react';
import PropTypes from 'prop-types';

// Multibrand-UI Components
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import Link from '@zg-rentals/multibrand-ui/lib/Link';
import Input from '@zg-rentals/multibrand-ui/lib/Input';
import Text from '@zg-rentals/multibrand-ui/lib/Text';

// style
import './style.scss';

const propTypes = {
    onSubmit: PropTypes.func,
    onClose: PropTypes.func.isRequired,
    targetEmail: PropTypes.string.isRequired,
    userName: PropTypes.string.isRequired,
};

const defaultProps = {
    onSubmit: () => { },
};

const ResendCompanyInviteModal = ({
    onSubmit,
    onClose,
    targetEmail,
    userName,
}) => {
    const [email, setEmail] = React.useState('');

    return (
        <div className="ResendCompanyInviteModal">
            <Text className="ResendCompanyInviteModal-instructions">
                {`Please confirm ${userName}'s email address.`}
            </Text>
            <Input
                type="text"
                placeholder="Name"
                label="Email"
                value={email}
                onChange={e => setEmail(e.target.value.trim())}
                error={null}
            />
            <div className="ResendCompanyInviteModal-controls">
                <Link onClick={onClose} className="ResendCompanyInviteModal-cancel">
                    Cancel
                </Link>
                <Button
                    onClick={onSubmit}
                    type="primary"
                    disabled={email !== targetEmail}
                >
                    Resend Invite
                </Button>
            </div>
        </div>
    );
};

ResendCompanyInviteModal.propTypes = propTypes;
ResendCompanyInviteModal.defaultProps = defaultProps;

export { ResendCompanyInviteModal };
export default ResendCompanyInviteModal;
